import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TrialService } from '../../../core/services/trial.service';

/** The trial countdown before joining (room login and direct links). */
@Component({
  selector: 'andor-trial-notice',
  standalone: true,
  templateUrl: './trial-notice.html',
  styleUrl: './trial-notice.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialNotice {
  readonly trial = inject(TrialService);
}
